// Constants
export const STATUS_COLORS = {
    GREEN: "#10b981",
    YELLOW: "#f59e0b",
    RED: "#ef4444",
};

export const MAP_STYLE = { width: "100%", height: "400px" };

export const DEFAULT_CENTER = { lat: 19.0760, lng: 72.8777 };

export const getYesterdayDate = () => {
    const d = new Date();
    d.setDate(d.getDate() - 1);
    d.setHours(0, 0, 0, 0);
    return d;
};

export const getLastHourRange = () => {
    const end = new Date();
    const start = new Date(end.getTime() - 60 * 60 * 1000);
    return [start.toTimeString().slice(0, 5), end.toTimeString().slice(0, 5)];
};

export const buildTimestamps = (selectedDate, timeSelected) => {
    if (!selectedDate || !timeSelected?.[0] || !timeSelected?.[1]) return null;

    const [fromTime, toTime] = timeSelected;
    const createTimestamp = (timeStr) => {
        const [hours = 0, minutes = 0] = timeStr.split(":").map(Number);
        const date = new Date(selectedDate);
        date.setHours(hours, minutes, 0, 0);
        return date.getTime();
    };

    return {
        fromTimestamp: createTimestamp(fromTime),
        toTimestamp: createTimestamp(toTime),
    };
};

export const formatTimestamp = (timestamp) => {
    const date = new Date(timestamp);
    return date.toLocaleString('en-IN', {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: true
    });
};